export const ENABLE_PERFORMANCE_STATS =
  process.env.REACT_APP_ENABLE_3D_PERFORMANCE_STATS

export const PROPERTY_LABEL_PREFIX = 'Level'

export const NO_FOCUS_TARGETS: string[] = []
